import { CompanyContractPlan } from '@ulysses-inc/harami_api_client'

export type TraceKeySupportedPlan =
  | CompanyContractPlan.PREMIUM
  | CompanyContractPlan.BASIC
  | CompanyContractPlan.OLD_BASIC

export const isTraceKeySupportedPlan = (
  plan: CompanyContractPlan | null,
): plan is TraceKeySupportedPlan => {
  return (
    plan === CompanyContractPlan.PREMIUM ||
    plan === CompanyContractPlan.BASIC ||
    plan === CompanyContractPlan.OLD_BASIC
  )
}

const TRACE_KEY_LIMIT = {
  [CompanyContractPlan.PREMIUM]: 10,
  [CompanyContractPlan.BASIC]: 5,
  [CompanyContractPlan.OLD_BASIC]: 5,
} as const satisfies Record<TraceKeySupportedPlan, number>

/**
 * プランに応じた検索キーの上限数を取得
 */
export const getTraceKeyLimit = (plan: TraceKeySupportedPlan): number => {
  return TRACE_KEY_LIMIT[plan]
}
